import { render, staticRenderFns } from "./ArrearsTransactionGrid.vue?vue&type=template&id=3dc9e8cc"
import script from "./ArrearsTransactionGrid.vue?vue&type=script&lang=js"
export * from "./ArrearsTransactionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports